// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WuFHbHJgFUVdVi24cjw0 {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
  padding: 8px 10px;
  background: var(--vnsc-bg-primary, #1e293b);
  color: var(--vnsc-text-primary, #e2e8f0);
  font-family: var(--vnsc-font-family-base);
  font-size: var(--vnsc-font-size-sm, 12px);
}

/* Gom 9 tab loại lệnh thành wrap — không cắt chữ (P2-1). */
.WuFHbHJgFUVdVi24cjw0 .ADCtIEgUM7MQkSwQxr5r {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.WuFHbHJgFUVdVi24cjw0 .ADCtIEgUM7MQkSwQxr5r .UcP0zkAq6gSm5C4YIGyV,
.WuFHbHJgFUVdVi24cjw0 .ADCtIEgUM7MQkSwQxr5r .sXQ0JctERpccCdAhgO8w {
  flex: 0 0 auto;
  min-width: 0;
  padding: 4px 6px;
  font-size: 11px;
  white-space: nowrap;
}

/* TIF thu vào select nhỏ (P2-2). */
.IYOWDCrcx0DcwAtEIDTs {
  display: flex;
  align-items: center;
  gap: 8px;
}

.clW_IjOurRFezqccTrY8 {
  font-size: 11px;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
}

.gRuSolM8SRb76zlTIrno {
  flex: 1;
  min-width: 0;
  padding: 4px 6px;
  border-radius: 6px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-primary, #0d141b);
  color: inherit;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

/* Vị thế đang mở (Pha 3 polish): hiện ngay trong panel. */
.jLpvIwbqQfAaf564pUr4 {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 6px;
  border-radius: 6px;
  background: var(--vnsc-bg-secondary, rgba(255, 255, 255, 0.04));
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: var(--vnsc-text-secondary, #787b86);
}

/* Quick ticket (P2-6): ẩn TP/SL/risk khi bật — conditional render đã xử lý,
   CSS này chỉ là fallback nếu element còn tồn tại trong DOM. */

/* TP/SL share one row (mini stacked labels fit narrow halves). */
.Euuig6SDaPFHJbaxr2sE {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
}

.Euuig6SDaPFHJbaxr2sE label {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  min-width: 0;
}

.Euuig6SDaPFHJbaxr2sE label input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px 6px;
  font-size: 12px;
}

/* Risk readout compact: single-line rows, no bulk. */
.eB5fyGMtFPK7HUXHqgmK {
  font-size: 11px;
  color: var(--vnsc-text-secondary, #787b86);
}

.eB5fyGMtFPK7HUXHqgmK > div > div {
  display: flex;
  justify-content: space-between;
  padding: 1px 0;
  font-variant-numeric: tabular-nums;
}

.F7IRBylWqOljEFz8jTYi {
  /* In normal flow right after content: no void above, no footer overlap. */
  padding: 9px 16px;
  border: none;
  border-radius: 8px;
  /* Token, không hard-code (AC7): đổi theme là nút đổi theo. */
  background: var(--vnsc-color-bullish, #16a34a);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: pre-wrap;
}

.F7IRBylWqOljEFz8jTYi:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

._9BdXbh_PvJUw2JAEYvuA {
  background: var(--vnsc-color-bearish, #dc2626);
}

/* Stop tab hint (P1-4): làm rõ stop-market vs stop-limit. */
.MhmR5gAed1TIa6EOh1GV {
  font-size: 10px;
  line-height: 1.35;
  color: var(--vnsc-text-secondary, #787b86);
  padding: 4px 6px;
  border-radius: 6px;
  background: var(--vnsc-bg-secondary, rgba(255, 255, 255, 0.04));
}
`, "",{"version":3,"sources":["webpack://./src/widget/trading/ticket/TradingDockPanel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,2CAA2C;EAC3C,wCAAwC;EACxC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,+DAA+D;EAC/D,eAAe;EACf,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;+DAC+D;;AAE/D,iEAAiE;AACjE;EACE,aAAa;EACb,oDAAoD;EACpD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,0EAA0E;EAC1E,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,8CAA8C;EAC9C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,4DAA4D;AAC5D;EACE,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,+DAA+D;AACjE","sourcesContent":[".dock {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  min-height: 0;\r\n  padding: 8px 10px;\r\n  background: var(--vnsc-bg-primary, #1e293b);\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  font-family: var(--vnsc-font-family-base);\r\n  font-size: var(--vnsc-font-size-sm, 12px);\r\n}\r\n\r\n/* Gom 9 tab loại lệnh thành wrap — không cắt chữ (P2-1). */\r\n.dock .tabs {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n}\r\n\r\n.dock .tabs .tab,\r\n.dock .tabs .activeTab {\r\n  flex: 0 0 auto;\r\n  min-width: 0;\r\n  padding: 4px 6px;\r\n  font-size: 11px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* TIF thu vào select nhỏ (P2-2). */\r\n.tifRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.tifLabel {\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  white-space: nowrap;\r\n}\r\n\r\n.tifSelect {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-primary, #0d141b);\r\n  color: inherit;\r\n  font-size: 12px;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* Vị thế đang mở (Pha 3 polish): hiện ngay trong panel. */\r\n.positionRow {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  background: var(--vnsc-bg-secondary, rgba(255, 255, 255, 0.04));\r\n  font-size: 11px;\r\n  font-variant-numeric: tabular-nums;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n/* Quick ticket (P2-6): ẩn TP/SL/risk khi bật — conditional render đã xử lý,\r\n   CSS này chỉ là fallback nếu element còn tồn tại trong DOM. */\r\n\r\n/* TP/SL share one row (mini stacked labels fit narrow halves). */\r\n.dualField {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\r\n  gap: 8px;\r\n}\r\n\r\n.dualField label {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  min-width: 0;\r\n}\r\n\r\n.dualField label input {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 5px 6px;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Risk readout compact: single-line rows, no bulk. */\r\n.riskCompact {\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.riskCompact > div > div {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 1px 0;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.submitBar {\r\n  /* In normal flow right after content: no void above, no footer overlap. */\r\n  padding: 9px 16px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  /* Token, không hard-code (AC7): đổi theme là nút đổi theo. */\r\n  background: var(--vnsc-color-bullish, #16a34a);\r\n  color: #fff;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.submitBar:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.submitBarSell {\r\n  background: var(--vnsc-color-bearish, #dc2626);\r\n}\r\n\r\n/* Stop tab hint (P1-4): làm rõ stop-market vs stop-limit. */\r\n.hint {\r\n  font-size: 10px;\r\n  line-height: 1.35;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  background: var(--vnsc-bg-secondary, rgba(255, 255, 255, 0.04));\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dock": `WuFHbHJgFUVdVi24cjw0`,
	"tabs": `ADCtIEgUM7MQkSwQxr5r`,
	"tab": `UcP0zkAq6gSm5C4YIGyV`,
	"activeTab": `sXQ0JctERpccCdAhgO8w`,
	"tifRow": `IYOWDCrcx0DcwAtEIDTs`,
	"tifLabel": `clW_IjOurRFezqccTrY8`,
	"tifSelect": `gRuSolM8SRb76zlTIrno`,
	"positionRow": `jLpvIwbqQfAaf564pUr4`,
	"dualField": `Euuig6SDaPFHJbaxr2sE`,
	"riskCompact": `eB5fyGMtFPK7HUXHqgmK`,
	"submitBar": `F7IRBylWqOljEFz8jTYi`,
	"submitBarSell": `_9BdXbh_PvJUw2JAEYvuA`,
	"hint": `MhmR5gAed1TIa6EOh1GV`
};
export default ___CSS_LOADER_EXPORT___;
